const selectHeroImage = state => state.menu?.images?.[0] ?? null;

export default selectHeroImage;
